import { useContext } from 'react';
import { createContext } from 'react';

import { ProductSpecificationTextProps } from '../@types/ProductSpecificationTextProps';

export const ProductSpecificationTextContext = createContext<ProductSpecificationTextProps>(
	{} as ProductSpecificationTextProps,
);

ProductSpecificationTextContext.displayName = 'ProductSpecificationText';

const ProductSpecificationTextProvider = (props: ProductSpecificationTextProps) => (
	<ProductSpecificationTextContext.Provider value={props}>{props.children}</ProductSpecificationTextContext.Provider>
);

export const useProductSpecificationText = () => {
	const context = useContext(ProductSpecificationTextContext);

	return context;
};

export default ProductSpecificationTextProvider;
